import Joi from "joi";

export const accountSetupValidator = (data) => {
  const schema = Joi.object({
    name: Joi.string().required().messages({
      "string.empty": `"nama" tidak boleh kosong`,
    }),
    email: Joi.string()
      .email({
        tlds: {
          allow: false,
        },
      })
      .required()
      .messages({
        "string.empty": `"email" tidak boleh kosong`,
        "string.email": `"${data.email}" bukan email yang valid`,
      }),
    password: Joi.string().min(6).required().messages({
      "string.empty": `"password" tidak boleh kosong`,
      "string.min": "Gunakan password yang lebih kuat",
    }),
  });
  return schema.validate(data);
};

export const signUpValidator = (data) => {
  const schema = Joi.object({
    workingPlace: Joi.string().required().messages({
      "string.empty": `"Tempat praktek" tidak boleh kosong`,
    }),
    strNumber: Joi.string().required().messages({
      "string.empty": `"Nomor STR" tidak boleh kosong`,
    }),
  });
  return schema.validate(data);
};
